import React from 'react';
import { DollarSign, Clock, Briefcase, Shield, Search, TrendingUp, List, FileText } from 'lucide-react';

const reportGroups = [
  {
    category: 'Financial',
    reports: [
      { id: 'ar-aging', name: 'AR Aging', icon: DollarSign, description: 'Outstanding invoices by age' },
      { id: 'wip', name: 'Work in Progress', icon: Clock, description: 'Unbilled time & expenses by case' },
      { id: 'trust-balances', name: 'Trust Balances', icon: Shield, description: 'Trust account balances & allocations' },
      { id: 'revenue', name: 'Revenue', icon: TrendingUp, description: 'Billed & collected by attorney and case' },
    ],
  },
  {
    category: 'Time & Cases',
    reports: [
      { id: 'billable-hours', name: 'Billable Hours', icon: Clock, description: 'Hours by attorney, case, or type' },
      { id: 'case-status', name: 'Case Status', icon: Briefcase, description: 'Cases by status, type, or attorney' },
      { id: 'case-list', name: 'Case List', icon: List, description: 'List of cases for a time period' },
      { id: 'time-log', name: 'Time Log Detail', icon: FileText, description: 'Individual time entries with filters' },
    ],
  },
  {
    category: 'Revenue Optimization',
    reports: [
      { id: 'unbilled-activity', name: 'Unbilled Activity Finder', icon: Search, description: 'Find unbilled revenue opportunities' },
      { id: 'effective-rate', name: 'Effective Hourly Rate', icon: TrendingUp, description: 'Profitability of flat-fee & contingency cases' },
    ],
  },
];

const ReportSelector = ({ selectedReport, onSelect }) => {
  return (
    <div className="w-64 flex-shrink-0">
      <div className="bg-white rounded-lg shadow">
        {reportGroups.map((group) => (
          <div key={group.category}>
            <div className="px-4 py-2 bg-gray-50 border-b border-gray-200 first:rounded-t-lg">
              <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider">{group.category}</h3>
            </div>
            {group.reports.map((report) => {
              const Icon = report.icon;
              const isActive = selectedReport === report.id;
              return (
                <button
                  key={report.id}
                  onClick={() => onSelect(report.id)}
                  className={`w-full text-left px-4 py-3 border-b border-gray-100 last:border-b-0 transition-colors flex items-start gap-3 ${
                    isActive
                      ? 'bg-yellow-50 border-l-4 border-l-yellow-500'
                      : 'hover:bg-gray-50'
                  }`}
                >
                  <Icon className={`h-4 w-4 mt-0.5 flex-shrink-0 ${isActive ? 'text-yellow-600' : 'text-gray-400'}`} />
                  <div>
                    <div className={`text-sm font-medium ${isActive ? 'text-yellow-800' : 'text-gray-700'}`}>{report.name}</div>
                    <div className="text-xs text-gray-500">{report.description}</div>
                  </div>
                </button>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportSelector;
